import API from 'api';
import { message } from 'antd';
import getFormattedValues from 'utils/formatValues';
import _logger from 'utils/logger';
import { toMoment } from 'utils/normalizers';
import { DATE_FORMAT } from 'utils/formatters';
import { CATALOGOS_DE_CANAL_DE_PAGO } from 'utils/env';
import { postHistorialDeCita } from 'api/tramites/historialDeCita';
import store from 'store/store';
import { selectUser } from 'store/auth';
import { getNombreCompleto } from 'utils/padronesToString';

export const baseURI = 'recaudacion/citas-portal/';

const formatterHorarios = (c) => ({
  id: c.id,
  plantilla_de_tramite: c.plantilla_de_tramite,
  horario_inicio: toMoment(`${c.fecha_cita} ${c.horario_inicio}`, [`${DATE_FORMAT} hh:mm:ss`]),
  horario_fin: toMoment(`${c.fecha_cita} ${c.horario_fin}`, [`${DATE_FORMAT} hh:mm:ss`]),
});

const formatterCita = (_cita) => ({
  ..._cita,
  nombre_completo: _cita.cita_en_representacion
    ? `${_cita.nombre_representa} ${_cita.apellido_paterno_representa} ${_cita.apellido_materno_representa || ''} `.trim()
    : getNombreCompleto(selectUser(store.getState())),
});

/**
 * GET Citas
 * param {object} params
 * @returns {Promise<object>}
 */
export const getHorariosCitas = async (params) => {
  try {
    const response = await API.get('recaudacion/horarios-de-citas-public', { params });
    if (!response.data.next) {
      if (response.data.results) return response.data.results.map(formatterHorarios);
      return response.data.map(formatterHorarios);
    }
    const page = new URL(response.data.next).searchParams.get('page');
    const _citas = await getHorariosCitas({ ...params, page });
    response.data.results = response.data.results.map(formatterHorarios);
    return response.data.results.concat(_citas);
  } catch (err) {
    _logger(err);
    return [];
  }
};

/**
 * GET Citas
 * param {object} params
 * @returns {Promise<object>}
 */
export const getCitas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    response.data.results = response.data.results.map(formatterCita);
    return response.data;
  } catch (err) {
    _logger(err);
    return { results: [] };
  }
};

export const postReenviarAcuseCita = async (values) => {
  try {
    const response = await API.post('/recaudacion/reenviar-correo-cita', values);
    message.info(response.data.detail || 'Enviado');
  } catch (err) {
    _logger(err);
  }
};

/**
 * POST Cita
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCita = async (_values) => {
  try {
    const values = getFormattedValues({
      ..._values,
      catalogo_canal_de_pago: CATALOGOS_DE_CANAL_DE_PAGO.PAGO_EN_LINEA,
    });
    const response = await API.post(baseURI, values);
    await postHistorialDeCita({
      cita: response.data.id,
      observaciones: 'Cita programada',
      estado_de_cita: 1,
    });
    message.info(response.detail || 'Agregado correctamente');
    return response.data;
  } catch (err) {
    _logger(err);
    return false;
  }
};

/**
 * PATCH Cita
 * @param {number} id
 * @param {number} razon_de_rechazo_cita
 * @returns {Promise<object|boolean>}
 */
export const patchCancelarCita = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/cancelar`, values);
    message.info(response.detail || 'Editado correctamente');
    return response.data;
  } catch (err) {
    _logger(err);
    return false;
  }
};
